import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../../Context/GlobalContext";

const useRegister = () => {
  const { api } = useContext(GlobalContext);

  const [registerLoading, setRegisterLoading] = useState(false);

  const registerUserApi = async (registerData) => {
    try {
      setRegisterLoading(true);

      const payload = {
        firstName: registerData?.firstName || "",
        lastName: registerData?.lastName || "",
        email: registerData?.email || "",
        phone: registerData?.phone || "",
        password: registerData?.password || "",
        confirmPassword: registerData?.confirmPassword || "",
        usertype: registerData?.usertype || "customer",
      };

      const response = await api.post(
        "/api/Driver/v1.0/registerUser",
        payload
      );

      const data = response.data;

      if (data.responseCode === "00" || data.success) {
        return {
          success: true,
          message:
            data.responseMessage || data.message || "OTP Sent Successfully",
          data,
        };
      }

      return {
        success: false,
        message: data.responseMessage || data.message || "Registration Failed",
        data,
      };
    } catch (error) {
      console.error("Register User Error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Something went wrong"
      );

      return null;
    } finally {
      setRegisterLoading(false);
    }
  };

  return {
    registerLoading,
    registerUserApi,
  };
};

export default useRegister;